var _desc, _defs, _mask, _use, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "placeholder_user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mann_02"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Oval-2",
    fill: "#5E7887",
    xlinkHref: "#path-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7055556,30.9361111 C20.2533028,30.9361111 21.5774681,30.6037595 22.6927845,29.9841223 L22.6931374,31.4058777 C24.1576115,32.0150139 25.5044987,32.9075926 26.6497983,34.0490745 C28.9639364,36.3554988 30.2646296,39.4883201 30.2646296,42.7555556 L29.8877778,64.4074074 C29.8877778,71.0962465 24.8878461,71.9208041 18.2413824,71.9439277 L17.9381481,71.9444444 C11.147963,71.9444444 5.29648148,71.1975926 5.29648148,64.4074074 L5.63907407,42.7624074 C5.65473811,37.112102 9.46879968,32.355598 14.6631496,30.9123127 L14.6628855,29.9529868 C15.789686,30.5926194 17.1320827,30.9361111 18.7055556,30.9361111 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.37037037,
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7055556,4.28925926 C13.8544444,4.28925926 9.92148148,8.22757523 9.92148148,15.217963 C9.92148148,22.9194444 13.5152588,28.1953704 18.7055556,28.1953704 C23.8958523,28.1953704 27.4896296,22.9194444 27.4896296,15.217963 C27.4896296,8.2586896 23.5566667,4.28925926 18.7055556,4.28925926 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.37037037,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9027778,15.217963 C15.2973816,15.2645896 15.5830189,15.6170782 15.5468519,16.0127778 C15.4875319,16.3761814 15.1516034,16.6277248 14.7861955,16.5823575 C14.4207877,16.5369902 14.156571,16.2109356 14.1879192,15.8440591 C14.2192674,15.4771826 14.5349703,15.2006799 14.9027778,15.217963 Z M22.7207407,15.217963 C23.1153445,15.2645896 23.4009819,15.6170782 23.3648148,16.0127778 C23.3054948,16.3761814 22.9695663,16.6277248 22.6041585,16.5823575 C22.2387507,16.5369902 21.974534,16.2109356 22.0058822,15.8440591 C22.0372304,15.4771826 22.3529332,15.2006799 22.7207407,15.217963 Z",
    id: "Shape",
    stroke: "#5E7887",
    strokeWidth: 0.685185185,
    fill: "#5E7887",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4801852,19.2331481 C20.4801852,19.8087037 19.7333333,20.2746296 18.8151852,20.2746296 C17.9108344,20.2746296 17.2616148,19.7538889 17.0616297,19.2331481",
    id: "Shape",
    stroke: "#5E7887",
    strokeWidth: 0.6,
    style: {
      mixBlendMode: "multiply"
    },
    strokeLinecap: "round",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2368014,22.6549064 C16.487711,24.7198058 21.0549476,24.7015036 22.2949839,22.6",
    id: "Shape",
    stroke: "#5E7887",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    mask: "url(#mask-2)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.5,
    cy: 17.5,
    rx: 1.5,
    ry: 2.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 28.5,
    cy: 17.5,
    rx: 1.5,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.0173577,13.6321507 C13.4873577,13.4321507 14.6023577,13.1621507 15.2773577,13.6321507",
    id: "Shape",
    stroke: "#5E7887",
    strokeWidth: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    strokeLinecap: "round",
    transform: "translate(14.147358, 13.621406) rotate(-20.000000) translate(-14.147358, -13.621406) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0173577,13.6321507 C22.4873577,13.4321507 23.6023577,13.1621507 24.2773577,13.6321507",
    id: "Shape",
    stroke: "#5E7887",
    strokeWidth: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    strokeLinecap: "round",
    transform: "translate(23.147358, 13.621406) scale(-1, 1) rotate(-20.000000) translate(-23.147358, -13.621406) "
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2585449,6 C23.5350998,5.68185999 23.8206789,4.00717732 26.1131592,6 C27.9985889,7.63897907 28.8885498,10.4216683 28.8885498,12.12 C28.8885498,13.15 28.9095189,14.3494022 28.6140137,15 C28.1094511,16.1108679 28.1094511,17.522583 27.9277344,17.522583 C27.9277344,17.522583 27.7041447,13.0350726 27.4896296,13.15 C26.4268009,13.7194154 24.7472065,12.0181513 22.8397217,10.36 C20.5472414,8.36717732 22.98199,6.31814001 23.2585449,6 Z M11.5432129,5 C14.3181152,2.28476595 20.6996031,2.07639223 22.5377197,4 C23.7786319,5.29862721 23.4729094,5.30823058 22.2839355,6.65049952 C21.5045289,7.53039551 21.5045289,7.88862319 20.7659912,8.45873311 C20.0953322,8.97644444 18.5915527,9.52297507 17.234375,10.36 C14.3724592,12.1250561 10.4577636,13.095094 10.3161621,13.503418 C9.77223711,15.0718872 9.92148148,17.4581604 9.68557739,17.4581604 C9.68557739,17.4581604 9.85211182,15.4823688 8.76400757,14.9502869 C7.67590332,14.4182049 7.50534374,14.467918 7.79272461,12.12 C8.1105957,9.52297507 8.76831055,7.71523405 11.5432129,5 Z",
    id: "Oval-3",
    stroke: "#5E7887",
    strokeWidth: 0.7,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar_default.9fe54719fdb57221005a7259c0f1b5e7.svg";
export { ForwardRef as ReactComponent };